import { useMutation, useQuery } from '@tanstack/react-query';

import { useToaster } from '@components/toaster';
import { useScopedTranslate } from '@locale/translate';

import {
  h3coreEnabled,
  h3coreBulkEditGetData,
  h3coreBulkEditCreateData,
  H3BulkEditCreateData,
  H3BulkCreateData,
  h3coreBulkCreate,
} from './api';

export function useIsH3CoreEnabled() {
  const query = useQuery({
    queryKey: ['h3coreEnabled'],
    queryFn: h3coreEnabled,
  });

  return query.isSuccess && query.data.enabled;
}

export function useH3CoreBulkEditData() {
  return useQuery({
    queryKey: ['h3coreBulkEditData'],
    queryFn: h3coreBulkEditGetData,
  });
}

export const useH3BulkCreateData = () => {
  const { t } = useScopedTranslate(locale);

  const { showError, showSuccess } = useToaster();
  return useMutation(
    (props: H3BulkEditCreateData & { onSuccess?: () => void }) =>
      h3coreBulkEditCreateData({ applicationIds: props.applicationIds, fields: props.fields }),
    {
      onSuccess: (_, { onSuccess }) => {
        showSuccess(t('dataSaved'));
        onSuccess?.();
      },
      onError: () => {
        showError(t('dataNotSaved'));
      },
    }
  );
};

export const useH3BulkCreate = () => {
  const { t } = useScopedTranslate(locale);

  const { showError, showSuccess } = useToaster();
  return useMutation(
    (props: H3BulkCreateData & { onSuccess?: () => void }) =>
      h3coreBulkCreate({ applicationIds: props.applicationIds }),
    {
      onSuccess: (_, { onSuccess }) => {
        showSuccess(t('dataWillBeCreated'));
        onSuccess?.();
      },
      onError: () => {
        showError(t('dataNotCreated'));
      },
    }
  );
};

const locale = {
  en: {
    dataSaved: 'Data saved',
    dataNotSaved: 'Data saved',
    dataWillBeCreated: 'Data will be created in H3',
    dataNotCreated: 'Data was not created',
  },
  is: {
    dataSaved: 'Gögn vistuð',
    dataNotSaved: 'Gögn ekki vistuð',
    dataWillBeCreated: 'Gögn verða stofnuð í H3',
    dataNotCreated: 'Gögn voru ekki stofnuð',
  },
};
